import React, { useEffect } from 'react';

// This component serves the apple-developer-domain-association.txt content
const AppleDomainVerification: React.FC = () => {
  useEffect(() => {
    // Get the content from the public folder
    fetch('/.well-known/apple-developer-domain-association.txt')
      .then(response => response.text())
      .then(content => {
        // Replace the entire document with just the text content
        document.body.innerHTML = '';
        const pre = document.createElement('pre');
        pre.textContent = content;
        document.body.appendChild(pre);
        // Set the correct content type using response headers
        // Note: We can't modify document.contentType as it's read-only
      })
      .catch(error => {
        console.error('Error loading verification file:', error);
      });
  }, []);

  // Return an empty div that will be replaced with the file content
  return <div />;
};

export default AppleDomainVerification;
